import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { InfoChips } from "@website/ui/info-chips";
import type { ListItemPropertiesType } from "@website/ui/list-item";
import { ListItem } from "@website/ui/list-item";
import { isChannel } from "@website/utils/channel/helpers";
import { useRouter } from "next/router";
import { useState } from "react";
import { useNavbar } from "./navbar.hook";
type NavbarListItem = Omit<ListItemPropertiesType, "onClick"> & {
  hasNewLabel?: boolean;
  id?: string;
  onClick?: () => void;
  selected?: boolean;
  subItems?: Array<NavbarListItem>;
};
export const Navbar = () => {
  const $ = _c(17);
  const {
    list,
    profileType,
    isCollapsed,
    setIsCollapsed
  } = useNavbar();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [expandedItems, setExpandedItems] = useState(t0);
  const router = useRouter();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = id => {
      if (!id) {
        return;
      }
      setExpandedItems(state => ({
        ...state,
        [id]: !state[id]
      }));
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleSubItems = t1;
  const t2 = `${router.pathname === "/" ? "" : "max-lg:hidden"} lg:border-outline-thin mb-6 max-lg:w-full lg:sticky lg:h-fit lg:rounded-lg lg:border ${isCollapsed ? "px-2 py-3 lg:w-[96px]" : "p-6 lg:w-[312px] lg:p-4"} lg:duration-500 ${isChannel(["jek"]) ? "lg:top-4" : "lg:top-20"}`;
  let t3;
  if ($[2] !== isCollapsed || $[3] !== profileType || $[4] !== setIsCollapsed) {
    t3 = profileType === "B2B" && <div className={`bg-gray absolute -left-px top-12 flex size-6 -translate-x-1/2 cursor-pointer items-center justify-center rounded-full bg-opacity-[87%] duration-1000 max-lg:hidden ${isCollapsed ? "rotate-180" : "rotate-0"}`} onClick={() => setIsCollapsed(_temp)}><div className="size-0 border-y-4 border-l-4 border-y-transparent border-l-white" /></div>;
    $[2] = isCollapsed;
    $[3] = profileType;
    $[4] = setIsCollapsed;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `overflow-hidden ${isCollapsed ? "lg:w-[78px]" : "lg:w-[280px]"}`;
  let t5;
  if ($[6] !== expandedItems || $[7] !== isCollapsed || $[8] !== list) {
    t5 = list?.filter(_temp2).map((item_0, index) => {
      const navbarItem = item_0 as NavbarListItem;
      const hasSubItems = Boolean(navbarItem.subItems?.length);
      const isExpanded = !isCollapsed && (navbarItem.selected || Boolean(navbarItem.id && expandedItems[navbarItem.id]));
      return <div key={navbarItem.id || navbarItem.title as string} className={hasSubItems && isExpanded ? "lg:border-states-secondary-hover lg:overflow-hidden lg:rounded-lg lg:border" : ""}><ListItem isCollapsed={isCollapsed} {...navbarItem} EndIcon={hasSubItems ? <MaterialIcon name={isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"} /> : navbarItem.EndIcon} className={`hover:bg-states-secondary-hover border-outline-thin !px-2 max-lg:border-t lg:rounded-xl ${index === 0 ? "border-0" : ""} ${hasSubItems && isExpanded ? "bg-states-secondary-hover !rounded-none" : ""} ${navbarItem.selected && !hasSubItems ? "bg-states-secondary-dragged text-secondary rounded-lg" : ""} `} onClick={() => {
          if (hasSubItems) {
            toggleSubItems(navbarItem.id);
            return;
          }
          if (navbarItem.role === "button") {
            navbarItem.onClick?.();
          }
        }} title={navbarItem.hasNewLabel ? <div className="flex items-center gap-4">{navbarItem.title}<InfoChips className="!rounded-3xl" color="primary" size="small" text={"\u062C\u062F\u06CC\u062F"} /></div> : navbarItem.title} />{hasSubItems && isExpanded && <div className="rounded-b-lg">{navbarItem.subItems?.map(subItem => <ListItem isCollapsed={isCollapsed} key={subItem.id || subItem.title as string} {...subItem} title={<span className="text-subtitle-2">{subItem.title}</span>} className={`hover:bg-states-secondary-hover !h-10 !px-2 ${subItem.selected ? "bg-states-secondary-dragged text-secondary" : ""}`} onClick={() => {
            if (subItem.role === "button") {
              subItem.onClick?.();
            }
          }} StartIcon={<div className="border-surface-medium-emphasis mx-auto mt-3 w-4 border" />} />)}</div>}</div>;
    });
    $[6] = expandedItems;
    $[7] = isCollapsed;
    $[8] = list;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t6) {
    t7 = <div className={t2}>{t3}{t6}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
function _temp(s) {
  return !s;
}
function _temp2(item) {
  return item?.title || item?.id;
}